
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/overnatting",
      function () {
        return require("private-next-pages/[region]/overnatting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/overnatting"])
      });
    }
  